$(document).ready(function () {
  // Partners logos slider start

  if ($(".js-cwr-parteners-slider").length > 0) {
    $(".js-cwr-parteners-slider").slick({
      dots: false,
      arrows: false,
      infinite: true,
      lazyLoad: "progressive",
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: true,
      // slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  }

  // Partners logos slider end

  // Product details slider start

  if ($(".js-cwr-product-details-main-slider").length > 0) {
    $(".js-cwr-product-details-main-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".js-cwr-product-details-nav-slider",
    });
  }

  if ($(".js-cwr-product-details-nav-slider").length > 0) {
    $(".js-cwr-product-details-nav-slider").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      lazyLoad: "progressive",
      asNavFor: ".js-cwr-product-details-main-slider",
      arrows: false,
      focusOnSelect: true,
    });
  }

  // Product details slider start

  // Extra Product slider start

  if ($(".js-cwr-product-details-extra-product-slider").length > 0) {
    $(".js-cwr-product-details-extra-product-slider").slick({
      lazyLoad: "progressive",
      slidesToShow: 1.7,
      infinite: false,
      arrows: false,
      dots: true,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1.5,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1.2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Extra Product slider end

  // Size guide popup toggle start

  if ($(".js-dog-size-guide-button").length > 0) {
    $(".js-dog-size-guide-button").click(function (event) {
      event.preventDefault();
      $(".js-dog-size-guide-popup").toggleClass("is-active");
    });
  }

  if ($(".js-dog-size-guide-popup-close-btn").length > 0) {
    $(".js-dog-size-guide-popup-close-btn").click(function () {
      $(".js-dog-size-guide-popup").removeClass("is-active");
    });
  }

  // Size guide popup toggle end

  /* scroll to target start */

  // jQuery('.scrollTo').click(function(e) {
  //     e.preventDefault();
  //     var jump = jQuery(this).attr('href');
  //     var new_position = jQuery(jump).offset();
  //     var scroll = 0;
  //     jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
  //         var new_position = jQuery(jump).offset();
  //         jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);

  //     });
  // });

  // $('.scrollTo').on('click',function (e) {
  //     e.preventDefault();
  //     var target = this.hash;
  //     var $target = $(target);
  //     $('html, body').stop().animate({
  //         'scrollTop': $target.offset().top
  //     }, 900, 'swing', function () {
  //         // window.location.hash = target;
  //     });
  // });

  /* scroll to target end */

  // Add class when using safari browser start

  if (
    navigator.userAgent.indexOf("Safari") != -1 &&
    navigator.userAgent.indexOf("Chrome") == -1
  ) {
    $("body").addClass("safari");
  }

  // Add class when using safari browser end

  // You will love video play pouse start

  if ($(".js-cwr-media-content-media-btn").length > 0) {
    var videoStatus = "pause";

    $(".js-cwr-media-content-media-btn").click(function () {
      let video = $(this).siblings("video");
      let videoBtn = $(this);

      if (videoStatus === "pause") {
        video[0].play();
        videoStatus = "play";
        videoBtn.addClass("is-active");
      } else {
        video[0].pause();
        videoStatus = "pause";
        videoBtn.removeClass("is-active");
      }
    });
  }

  // You will love video play pouse end

  // Othes JS start

  if ($(".accordion_faq").length > 0) {
    $(document).on("click", ".accordion_faq", function () {
      $(this).toggleClass("active");
      if ($(this).next(".panel").css("display") == "block") {
        $(this).next(".panel").toggle();
      } else {
        $(this).next(".panel").toggle();
      }
    });
  }

  // Othes JS end

  // Testimonial 2 slider start

  if ($(".js-cwr-testimonial-2-slider").length > 0) {
    $(".js-cwr-testimonial-2-slider").slick({
      lazyLoad: "progressive",
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Testimonial 2 slider end

  // matchHeight
  if ($(".card .content .title").length > 0) {
    $(".card .content .title").matchHeight({
      byRow: 0,
    });
  }
  if ($(".card .content .loox-rating").length > 0) {
    $(".card .content .loox-rating").matchHeight({
      byRow: 0,
    });
  }
  if ($(".card .content .price1").length > 0) {
    $(".card .content .price1").matchHeight({
      byRow: 0,
    });
  }
  if ($(".card .content .price2").length > 0) {
    $(".card .content .price2").matchHeight({
      byRow: 0,
    });
  }
  // end matchHeight

  // match height of cards on search page
  let searchCard = setInterval(function () {
    if ($(".grid .column img").length > 0) {
      $(".grid .column img").matchHeight({
        byRow: 1,
        property: "min-height",
      });
    }

    if ($(".grid .column h4").length > 0) {
      $(".grid .column h4").matchHeight({
        byRow: 1,
      });
    }

    if ($(".grid .column .rte p").length > 0) {
      $(".grid .column .rte p").matchHeight({
        byRow: 1,
      });
    }
    if ($(".grid .column .feature-link").length > 0) {
      $(".grid .column .feature-link").matchHeight({
        byRow: 1,
      });
    }
  }, 1000);

  setTimeout(function () {
    clearInterval(searchCard);
  }, 5000);
  // end

  // match height for custom blog temlate grid
  if ($("#myTabContent .content .title").length > 0) {
    $("#myTabContent .content .title").matchHeight({
      byRow: 1,
    });
  }

  if ($("#myTabContent .content span").length > 0) {
    $("#myTabContent .content span").matchHeight({
      byRow: 1,
    });
  }
  if ($("#myTabContent .content .custom-article-content").length > 0) {
    $("#myTabContent .content .custom-article-content").matchHeight({
      byRow: 1,
    });
  }

  if ($("#myTabContent .content .btn-solid-reg").length > 0) {
    $("#myTabContent .content .btn-solid-reg").matchHeight({
      byRow: 1,
    });
  }

   // Close Popup

   $('.close_fact_popup_img a').on('click', function(e){
    e.preventDefault();
    $('.cwr_facs_wrapper.offer_page').hide();
    $('body').removeClass('overflow-hidden');
  });

  $('.cwr-product-fact a').on('click', function(e){
    e.preventDefault();
    $('.cwr_facs_wrapper.offer_page').show();
    $('body').addClass('overflow-hidden');
  });

  // Recomandation Slider
  setTimeout(function () {
    if ($(".product-slider-bg.pdp_new_temp").length > 0) {
      $(".product-slider-bg.pdp_new_temp .like-product .row").slick({
        dots: false,
        arrows: true,
        infinite: false,
        lazyLoad: "progressive",
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });
    }
  }, 5000);

  mobileOnlySlider(".usp-slider", false, false, true, 2000, 991);

  function mobileOnlySlider($slidername, $dots, $arrows,  $autoplay, $autoplaySpeed, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      mobileFirst: true,
      dots: $dots,
      arrows: $arrows,
      autoplay: $autoplay,
      autoplaySpeed: $autoplaySpeed,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick"
        }
      ]
    };

    slider.slick(settings);

    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  } // Mobile Only Slider
  

  // if product has variant
  if($('.selector-wrapper #option-size').length){
    $('.selector-wrapper #option-size').on('change', function(){
      var get_title = $(this).val();
      $('.product-form .original-selector option').each(function(ie,em){
          var get_title_1 = $(em).text();
          if(get_title_1 == get_title){
              $(em).attr('selected', 'selected');
              var get_price = $(em).attr('data-price');
              var get_com_price = $(em).attr('data-comp-price'); 
              if($('.custom_onetime.product_one_subs').hasClass('Active-Tab')){
                $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price h4').text(get_price);
                if (get_com_price) {  
                  $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price .subcription_compare_price').removeClass('d-none');
                  $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price .subcription_compare_price del').text(get_com_price);

                }else{
                  $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price .subcription_compare_price').addClass('d-none');
                }
              }else{
                var get_selling_price = $(em).attr('data-selling-price');
                $('.custom_subscription.product_one_subs.Active-Tab .pro_subcription-widget .pro_subscription_price h4').text(get_selling_price);
              }
          }else{
            $(em).removeAttr('selected');
          }
      });
    });
  }

  $('.product_one_subs').on('click', function(){
    if($('.custom_onetime').length){
      if($(this).hasClass('custom_onetime')){
          var get_price = $('.product-form .original-selector option:selected').attr('data-price');
          var get_com_price = $('.product-form .original-selector option:selected').attr('data-comp-price'); 
          $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price h4').text(get_price);
          $('.custom_onetime.product_one_subs .pro_subcription-widget .pro_subscription_price .subcription_compare_price del').text(get_com_price);
      
      }else{
          var get_selling_price = $('.product-form .original-selector option:selected').attr('data-selling-price');
          if (get_selling_price) {  
            $('.custom_subscription.product_one_subs.Active-Tab .pro_subcription-widget .pro_subscription_price h4').removeClass('d-none');  
            $('.custom_subscription.product_one_subs.Active-Tab .pro_subcription-widget .pro_subscription_price h4').text(get_selling_price);     
          }else{
            $('.custom_subscription.product_one_subs.Active-Tab .pro_subcription-widget .pro_subscription_price h4').addClass('d-none');  
          }
      }
    }
  });


  // Fix alignment issue of ingredients_details_wrap on lp
  $('#landing-2 .ingredients_details_wrap,#landing-product .ingredients_details_wrap,#new-landing .ingredients_details_wrap').each(function() {
    if ($(this).find('h2').text().trim() === "Lion's Mane") {
        let paragraph = $(this).find('p');
        let currentText = paragraph.html();

        // Option 1: Add a space at the end of the text
        paragraph.html(currentText + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');

        // Option 2: Add a non-breaking space (optional if you want it to be non-breaking)
        // paragraph.html(paragraph.html() + '&nbsp;');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("input.quantity").forEach(function (ele) {
    ele.addEventListener("change", function () {
      isSetValue(ele);
    });
  });

  function isSetValue(ele) {
    if (
      ele.value == "" ||
      ele.value == " " ||
      ele.value == "0" ||
      ele.value == "00"
    ) {
      ele.value = 1;
    }
  }
});

setTimeout(function(){

console.log('is load');
// Update rewardbar message
function checkSubscription(items) {
  let hasSubscription = false;
  items.map((item) => {
    if (item.selling_plan_allocation) {
    hasSubscription = true;
    }
  });

  const rewardBar = window.upcartDocumentOrShadowRoot.querySelector(".upcart-rewards-message p"); // Adjust selector as needed
   const rewardBar_color = window.upcartDocumentOrShadowRoot.querySelector(".upcart-rewards-bar-background"); // Adjust selector as needed
    const rewardBar_icon = window.upcartDocumentOrShadowRoot.querySelector(".styles_TieredRewards__tiersContainer__"); // Adjust selector as needed
  if (hasSubscription) {
      console.log('is change');      
      if (rewardBar) {      
        rewardBar.textContent = "🎉 Congrats - You Unlocked Free Shipping! 🎉";        
        rewardBar_color.classList.add("hide");
        rewardBar_icon.classList.add("hide");
      }
   }else{
      rewardBar_color.classList.remove("hide");
      rewardBar_icon.classList.remove("hide");
   }
}
window.upcartModifyCart = (cart) => {
  setTimeout(() => {
    
    // let upsellWidget = window.upcartDocumentOrShadowRoot.querySelector('#up-upsell-carousel');
    // upsellWidget.style.display = 'none';
    // upsellWidget.classList.add("hide");   
    refreshcart(cart.items) ;
    checkSubscription(cart.items);
  }, 500);
  return cart;
};


// Remove from cart
window.upcartOnItemRemoved = async (_, removedItem) => {
  const removedItemVariantId = removedItem.variant_id;
  const isLandingPage = removedItem.properties?._islandingpage;

  // Only proceed if removed item has `_islandingpage`
  if (!isLandingPage) return;

  // Fetch current cart
  const res = await fetch('/cart.js');
  const cart = await res.json();

  for (const cartItem of cart.items) {
    // Skip the removed item itself
    if (cartItem.key === removedItem.key) continue;

    const freeProduct = cartItem.properties?._free_product;
    const mainProduct = cartItem.properties?._main_product;

    // Check if item has both _free_product and _main_product
    if (freeProduct && mainProduct) {
      // Check if mainProduct contains the removed item's variant ID
      const mainProductIds = mainProduct.split(','); // assuming CSV
      if (mainProductIds.includes(removedItemVariantId.toString())) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: cartItem.key, quantity: 0 })
        });
        console.log('Removed linked item:', cartItem.title);
      }
    }
  }

  // Refresh cart after changes
  window.upcartRefreshCart();
};

// Hide cart drawer
function hideRewards() {
  let rewardsBar = window.upcartDocumentOrShadowRoot.querySelector(".upcart-rewards");   
  //rewardsBar.classList.add("hide");

  let addOn = window.upcartDocumentOrShadowRoot.querySelector(".styles_AddonsModule__.upcart-addons");
  addOn.style.display = 'none';
  addOn.classList.add("hide");

  // hide upsell
  let upsellWidget = window.upcartDocumentOrShadowRoot.querySelector('#up-upsell-carousel');
  upsellWidget.style.display = 'none';
  upsellWidget.classList.add("hide");
}
window.upcartOnCartOpened = setTimeout(hideRewards, 300);
window.upcartOnCartLoaded = hideRewards;
// Hide cart drawer End

// refreshcart Start
  function refreshcart(items){    
      console.log('refresh cart');
      const upCartDiv = document.getElementById('upCart');
      if (upCartDiv && upCartDiv.shadowRoot) {
        const itemElements = upCartDiv.shadowRoot.querySelectorAll('.styles_ProductRow__product__');
          items.forEach((item, index) => {
          if (!itemElements[index]) return;
          const hasSpecialProperty = Object.keys(item.properties).some(key => key.includes('_islandingpage'));
          if (hasSpecialProperty) {
            const updatetext = itemElements[index].querySelector('.upcart-item-option-value');
            if (updatetext) {
              const textValue = updatetext.textContent.trim();
              if (textValue === 'Buy 3 Jars') {
                updatetext.textContent = textValue + ' + Get 2 FREE Gifts!';
              }else if(textValue === 'Buy 2 Jars'){
                updatetext.textContent = textValue + ' + 1 Free Omega Love +';
              }
            }
          }
        });
      }
  };

// open cart-drawer js
window.upcartOnCartOpened = function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(data => {
      const upCartDiv = document.getElementById('upCart');
     
      if (upCartDiv && upCartDiv.shadowRoot) {
          const itemElements = upCartDiv.shadowRoot.querySelectorAll('.styles_ProductRow__product__');
          data.items.forEach((item, index) => {
            if (!itemElements[index]) return;

            // Check for _free_product key to hide the element
            const isFreeProduct = Object.keys(item.properties).some(key => key.includes('_free_product'));
            if (isFreeProduct) {
              const hide_subscirbebutton = itemElements[index].querySelector('.SubscriptionUpgradesModule_section__');
              if (hide_subscirbebutton) {
                hide_subscirbebutton.style.display = 'none';
              }
              
              const quantityField = itemElements[index].querySelector('.styles_QuantityField__');
              if (quantityField) {
                quantityField.style.display = 'none';
              }
            }
            


            const hasSpecialProperty = Object.keys(item.properties).some(key => key.includes('_islandingpage'));
            if (hasSpecialProperty) {
              const updatetext = itemElements[index].querySelector('.upcart-item-option-value');
              if (updatetext) {
                const textValue = updatetext.textContent.trim();
                if (textValue === 'Buy 3 Jars') {
                  updatetext.textContent = textValue + ' + Get 2 FREE Gifts!';
                }else if(textValue === 'Buy 2 Jars'){
                  updatetext.textContent = textValue + ' + 1 Free Omega Love +';
                }
              }
              

              // const removeBtn = itemElements[index].querySelector('.styles_TrashButton__deleteButton__');
              // if (removeBtn) {
              //   removeBtn.style.display = 'none';
              // }
            }        
          });
       } else {
          console.log('Shadow DOM host element not found or no shadowRoot attached.');
      }
    }).catch(err => console.error('Cart fetch failed:', err));
};

},1000);
